module.exports = __webpack_public_path__ + "static/media/fr.d89e5168.svg";